import { render, staticRenderFns } from "./field-group.vue?vue&type=template&id=0e58280c&scoped=true&"
import script from "./field-group.vue?vue&type=script&lang=js&"
export * from "./field-group.vue?vue&type=script&lang=js&"
import style0 from "./field-group.vue?vue&type=style&index=0&id=0e58280c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e58280c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
